import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function EllipsisIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("circle", { cx: 5, cy: 12.23, r: 2, fill: primaryFillColor }), _jsx("circle", { cx: 12, cy: 12.23, r: 2, fill: primaryFillColor }), _jsx("circle", { cx: 19, cy: 12.23, r: 2, fill: primaryFillColor })] }));
}
//# sourceMappingURL=Ellipsis.js.map